module.exports = __webpack_public_path__ + "media/images/logo-shape-rotated-pink-eb62c69dc948ab10f1d3748e883b99ad.svg";